import { StaticBaseDao } from '@/dao';
import {
    Eventinfo,
    PostResponse,
    SearchRequest,
    EventNameDateId,
    EventSearchRequest,
    EventinfoSearchlistItem,
    EventinfoBase,
    FocusEvent,
    EventInfoSelectLine,
    CreateEventRequest,
    UpdateEventRequest,
    EventLocation,
} from '@/objects/generated';
import type { RoundType } from './../enums/RoundType';

export class EventDao extends StaticBaseDao {
    public static async Event(EventID: number): Promise<Eventinfo | null> {
        return this.BaseFetch(Eventinfo, `Event/Event` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`), 'GET');
    }
    public static async SaveEvent(eventinfo: Eventinfo): Promise<PostResponse | null> {
        return this.BaseFetch(PostResponse, `Event/SaveEvent`, 'POST', eventinfo);
    }
    public static async DeleteEvent(eventId: number): Promise<boolean | null> {
        return this.Delete(`Event/DeleteEvent` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`));
    }
    public static async TypeaheadSearch(request: SearchRequest): Promise<EventNameDateId[]> {
        return this.BaseFetchArray(EventNameDateId, `Event/TypeaheadSearch`, 'POST', request);
    }
    public static async SearchEvents(request: EventSearchRequest): Promise<Eventinfo[]> {
        return this.BaseFetchArray(Eventinfo, `Event/SearchEvents`, 'POST', request);
    }
    public static async SearchEventinfoSearchlistItems(request: EventSearchRequest): Promise<EventinfoSearchlistItem[]> {
        return this.BaseFetchArray(EventinfoSearchlistItem, `Event/SearchEventinfoSearchlistItems`, 'POST', request);
    }
    public static async GetActiveEventsForUser(): Promise<EventinfoBase[]> {
        return this.BaseFetchArray(EventinfoBase, `Event/Active`, 'GET');
    }
    public static async Focus(type?: string | null, count?: number): Promise<FocusEvent[]> {
        return this.BaseFetchArray(
            FocusEvent,
            `Event/Focus` + '?' + (type == undefined ? '' : `type=${type}`) + '&' + (count == undefined ? '' : `count=${count}`),
            'GET',
        );
    }
    public static async EventAsSelectLine(eventId: number): Promise<EventInfoSelectLine | null> {
        return this.BaseFetch(
            EventInfoSelectLine,
            `Event/EventAsSelectLine` + '?' + (eventId == undefined ? '' : `eventId=${eventId}`),
            'GET',
        );
    }
    public static async CreateEvent(createrequest: CreateEventRequest): Promise<EventinfoBase | null> {
        return this.BaseFetch(EventinfoBase, `Event/CreateEvent`, 'POST', createrequest);
    }
    public static async UpdateEvent(request: UpdateEventRequest, eventID: number): Promise<EventinfoBase | null> {
        return this.BaseFetch(
            EventinfoBase,
            `Event/UpdateEvent` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'POST',
            request,
        );
    }
    public static async SaveEventLocation(location: EventLocation, EventID: number): Promise<EventLocation | null> {
        return this.BaseFetch(
            EventLocation,
            `Event/SaveEventLocation` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            location,
        );
    }
    public static async SaveEventRankResolution(EventID: number, rankResolution: number): Promise<boolean | null> {
        return this.Get(
            `Event/SaveEventRankResolution` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (rankResolution == undefined ? '' : `rankResolution=${rankResolution}`),
        );
    }
    public static async SaveEventResultResolution(EventID: number, resultResolution: number): Promise<boolean | null> {
        return this.Get(
            `Event/SaveEventResultResolution` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (resultResolution == undefined ? '' : `resultResolution=${resultResolution}`),
        );
    }
    public static async SaveEventRoundType(EventID: number, roundtype: RoundType): Promise<boolean | null> {
        return this.Get(
            `Event/SaveEventRoundType` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (roundtype == undefined ? '' : `roundtype=${roundtype}`),
        );
    }
    public static async SaveEventAutoAssignBibs(EventID: number, autoassignbibs: boolean): Promise<boolean | null> {
        return this.Get(
            `Event/SaveEventAutoAssignBibs` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (autoassignbibs == undefined ? '' : `autoassignbibs=${autoassignbibs}`),
        );
    }
    public static async SaveEventAutoAssignEmitTags(EventID: number, autoassignemittag: boolean): Promise<boolean | null> {
        return this.Get(
            `Event/SaveEventAutoAssignEmitTags` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (autoassignemittag == undefined ? '' : `autoassignemittag=${autoassignemittag}`),
        );
    }
    public static async GetPreviousEventsForOrganizer(months: number, sportId: number | null): Promise<EventinfoBase[]> {
        return this.BaseFetchArray(
            EventinfoBase,
            `Event/GetPreviousEventsForOrganizer` +
                '?' +
                (months == undefined ? '' : `months=${months}`) +
                '&' +
                (sportId == undefined ? '' : `sportId=${sportId}`),
            'GET',
        );
    }
    public static async CopyContestantsFromEvent(EventID: number, SourceEventID: number): Promise<boolean | null> {
        return this.Get(
            `Event/CopyContestantsFromEvent` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (SourceEventID == undefined ? '' : `SourceEventID=${SourceEventID}`),
        );
    }
}
